import { render, staticRenderFns } from "./Side-Trouble-Dynamic-Group.vue?vue&type=template&id=c4ecd64c"
import script from "./Side-Trouble-Dynamic-Group.vue?vue&type=script&lang=js"
export * from "./Side-Trouble-Dynamic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports